import axios from "axios";
import { config } from "../utils/conf";
import { requestHeaders } from "../utils/http";

export const submitNotification = (accessToken, orderNumber) => {
  return {
    type: "SUBMIT_NOTIFICATION",
    payload: axios.post(
      `${config.orderApiUrl}/v1/erp-order-events`,
      { orderNumber },
      { headers: requestHeaders(accessToken) },
    ),
  };
};

export const reset = () => {
  return {
    type: "RESET_STATE",
  };
};
